import blank from 'spiceutils/dist/blank'
import dig from 'spiceutils/dist/dig'

export const getEntry = (key) => {
  const value = localStorage.getItem(key)
  try {
    return JSON.parse(value)
  } catch (e) {
    return value
  }
}

export const getData = (key, digArgs = []) => dig(getEntry(key), digArgs)

export const setData = (key, digArgs, data) => {
  let entry = getEntry(key) || {}

  if (!blank(digArgs)) {
    digArgs.reduce((current, key, index, array) => {
      const lastItem = index === array.length - 1

      if (lastItem) {
        // eslint-disable-next-line no-param-reassign
        current[key] = data
        return data
      }
      if (!current[key]) {
        const nextKey = array[index + 1]
        if (typeof nextKey === 'number') {
          // eslint-disable-next-line no-param-reassign
          current[key] = []
        } else {
          // eslint-disable-next-line no-param-reassign
          current[key] = {}
        }
      }
      return current[key]
    }, entry)
  } else {
    entry = data
  }

  localStorage.setItem(key, JSON.stringify(entry))
}
